import constants from 'constants/constants';
import moment from 'moment-timezone';

export const BoxLabels = {
    activity: 'Activity',
    currentPlannedFinish: 'Current Planned Finish',
    optimisticForecast: 'Optimistic Forecast',
    mostLikelyForecast: 'Most Likely Forecast',
    pessimisticForecast: 'Pessimistic Forecast',
} as const;

export const formatDate = (date: number | null | undefined) => {
    if (!date) {
        return 'N/A';
    }
    return moment(date).format(constants.formats.date.default);
};
export const formatVarianceString = (variance: number | null) => {
    if (!variance) {
        return '';
    }
    return ` (${variance >= 0 ? '+' : ''}${variance.toLocaleString()}d)`;
};

export const displayProbability = (probability: number) => {
    return Math.round(probability * 100);
};
